import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'timelineDetails',
        url: '/timelineDetails',
        component: 'wtTimelineDetailsState',
        params: {
            beginDate: '',
            endDate: ''
        },
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer, Roles.operator])
        },
        data: {
            sortingOrder: -1,
            icon: 'fa-compass',
            displayName: 'Processing status details',
            editRoles: [],
            editButtonVisibility: () => false,
        }
    }];

export default states;